<template>
  <b-modal id="bv-modal-create-paragraph" size="lg" hide-footer centered>
    <template v-slot:modal-title>
      Create Paragraph
    </template>
    <b-form @submit.prevent="createParagraph">

      <b-form-group
        id="paragraph-title-group"
        label="Paragraph Title"
        label-for="paragraph-title"
      >
        <b-form-input
          id="paragraph-title"
          v-model="createForm.title"
          type="text"
          required
          placeholder="Enter a title"
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary"><b-spinner small variant="light" v-if="isLoading"></b-spinner> Create</b-button> 
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

import {
  MONITOR_PARAGRAPH_CREATE
} from "@/store/actions.type";

export default {
  name: 'MonitorParagraphCreate',
  props: ['chapters'],
  data() {
    return {
      createForm: {
        title: ''
      },
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCurrent"])
  },
  methods: {
    createParagraph() {
      this.isLoading = true;

      let paragraphData = new FormData();
      paragraphData.set('name', this.createForm.title);
      paragraphData.set('order', this.monitorCurrent.paragraphs.length + 1);

      let payload = {
        chapterId: this.monitorCurrent.chapter.id,
        paragraphData: paragraphData
      }

      this.$store.dispatch(MONITOR_PARAGRAPH_CREATE, payload).then(() => {
        this.$bvModal.hide('bv-modal-create-paragraph');
        this.$bvToast.toast(`Paragraph ${this.createForm.title} has been created successfully`, {
          title: 'Paragraph created',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.resetForm();
        this.isLoading = false;
        this.$emit('paragraphCreated');
      });
    },
    resetForm() {
      this.createForm.title = '';
    }
  }
}
</script>